module.exports = __webpack_public_path__ + "img/duihao.f13ed817.png";